import React, {useState, useEffect} from 'react';
import axios from "axios";
import * as constants from "../constants/domains";
import {useCookies} from 'react-cookie'
import {toast} from "react-toastify";
import {Link} from "react-router-dom";

function EditUser() {

    const [userLoading, setUserLoading] = useState(false);
    const [updateUserLoading, setUpdateUserLoading] = useState(false);
    const [updatePasswordLoading, setUpdatePasswordLoading] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
    const [profilepic, setProfilepic] = useState('');
    const [validationError, setValidationError] = useState({});
    const Cookie = useCookies(['user_server_token']);
    const cookies = Cookie[0];
    const removeCookie = Cookie[2];

    const {user_server_token} = cookies;
    useEffect(() => {
        setUserLoading(true)

        if (!user_server_token){
            window.location.href = constants.$loginPage;
        }
        else{

            axios.get(constants.$apiUrl + '/api/user-info', {
                headers: {
                    "Authorization": "Bearer " + user_server_token
                }
            })
                .then((response) => {


                    setName(response.data.data.user.name ? response.data.data.user.name : "");
                    setEmail(response.data.data.user.email ? response.data.data.user.email : "");
                    setUsername(response.data.data.user.username ? response.data.data.user.username : "");
                    setProfilepic(response.data.data.user.profilepic ? constants.$authUrl+ "/warehouse/profileimg/_250/" + response.data.data.user.profilepic : constants.$authUrl+ "/warehouse/profileimg/_250/sample-icon.png");


                    setUserLoading(false)
                })
                .catch((err) => {
                    if (err.response && err.response.status === 401) {
                        removeCookie('user_server_token', { domain: constants.$cookieURL ,path: '/' });
                        window.location.href = constants.$loginPage;
                    } else {
                        toast.error('مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }
                    setUserLoading(false)

                })

        }
    }, [user_server_token , removeCookie])


    const userFormSubmit = (event) => {
        event.preventDefault();
        setValidationError({});
        setUpdateUserLoading(true)
        axios.post(constants.$apiUrl + '/api/user', {
            _method: "PUT",
            name: name,
            email: email,
        }, {
            headers: {
                "Authorization": "Bearer " + user_server_token
            }
        })
            .then(() => {
                toast.success('اطلاعات شما با موفقیت ویرایش شد.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setUpdateUserLoading(false)

            })
            .catch((error) => {
                if (error.response && error.response.status === 400) {
                    setValidationError({...error.response.data.data})
                } else {
                    toast.error('مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
                setUpdateUserLoading(false)

            })
    }


    const passwordFormSubmit = (event) => {
        event.preventDefault();
        setValidationError({});
        setUpdatePasswordLoading(true);
        axios.post(constants.$apiUrl + '/api/user/password-update', {
            _method: "PUT",
            password: password,
            newPassword: newPassword,
            newPasswordConfirm: newPasswordConfirm,

        }, {
            headers: {
                "Authorization": "Bearer " + user_server_token
            }
        })
            .then(() => {
                setUpdatePasswordLoading(false)
                toast.success('اطلاعات شما با موفقیت ویرایش شد.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            })
            .catch((error) => {
                setUpdatePasswordLoading(false)
                if (error.response && error.response.status === 400) {
                    setValidationError({...error.response.data.data})
                } else {
                    toast.error('مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            })
    }

    const uploadImageSubmit = (image) => {
        const data = new FormData()
        data.append('image', image)
        let url = constants.$apiUrl+"/api/user/upload-image";

        axios.post(url, data, {
            headers: {
                "Authorization": "Bearer " + user_server_token
            }
        })
            .then(() => { // then print response status
                toast.success('عکس پروفایل با موفقیت آپدیت شد.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            })
    }


    if (userLoading) {
        return <div className="container edit-profile py-5 direction-rtl">
            <div className="row">
                <div className="col-lg-2">
                    <div className="skeleton-box mb-2" style={{width:200 , height:200}} />
                    <div className="skeleton-box mb-2" style={{width:200 , height:40}} />
                </div>
                <div className="col-lg-10">
                    <div className="row">
                        <div className="col-lg mb-4">
                            <div className="skeleton-box w-25 skeleton-box-label"/>
                            <div className="skeleton-box w-100 skeleton-box-input"/>
                        </div>
                        <div className="col-lg mb-4">
                            <div className="skeleton-box w-25 skeleton-box-label"/>
                            <div className="skeleton-box w-100 skeleton-box-input"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 mb-4">
                            <div className="skeleton-box w-25 skeleton-box-label"/>
                            <div className="skeleton-box w-100 skeleton-box-input"/>
                        </div>
                    </div>
                    <div style={{height:40}} className="skeleton-box w-25"/>
                    <div style={{height:5}} className="skeleton-box w-100 my-4"/>
                    <div className="col-lg-6 mb-4">
                        <div className="skeleton-box w-25 skeleton-box-label"/>
                        <div className="skeleton-box w-100 skeleton-box-input"/>
                    </div>
                    <div className="col-lg-6 mb-4">
                        <div className="skeleton-box w-25 skeleton-box-label"/>
                        <div className="skeleton-box w-100 skeleton-box-input"/>
                    </div>
                    <div className="col-lg-6 mb-4">
                        <div className="skeleton-box w-25 skeleton-box-label"/>
                        <div className="skeleton-box w-100 skeleton-box-input"/>
                    </div>
                    <div style={{height:40}} className="skeleton-box w-25"/>
                </div>

            </div>


        </div>

    }

    return <React.Fragment>


        <div className="container edit-profile py-5 direction-rtl">


            <div className="row">
                <div className="col-lg-2">
                    <div className={"mb-2"}>
                        <div style={{maxWidth:200,margin:"0 auto"}}>
                            <label htmlFor="profilepic">
                                <img
                                    alt={"profile"}
                                    className={"img-fluid"}
                                    src={profilepic}/>
                            </label>

                        </div>
                        <input className={"d-none"} type="file" id={"profilepic"} onChange={(event) => {
                            setProfilepic(URL.createObjectURL(event.target.files[0]))
                            uploadImageSubmit(event.target.files[0])
                        }}/>
                    </div>

                    <div className={"mb-5 mt-4"}>
                        <Link to={"edit-address"} className={"btn btn-edit-user"}>ویرایش آدرس</Link>
                    </div>
                </div>

                <div className="col-lg-10">
                    <form onSubmit={userFormSubmit}>

                        <div className="row">
                            <div className="col-lg-6 mb-4">
                                <label htmlFor="username" className="form-label">شماره همراه</label>
                                <input value={username}
                                       id={"username"}
                                       disabled={true}
                                       className={"form-control" }
                                />
                            </div>
                            <div className="col-lg-6 mb-4">
                                <label htmlFor="name" className="form-label">نام و نام خانوادگی</label>
                                <input value={name}
                                       onChange={(event => setName(event.target.value))}
                                       id={"name"}
                                       type="text"
                                       className={"form-control " + (validationError['name'] && Array.isArray(validationError['name']) ? 'not-valid ' : '')}
                                       placeholder="نام و نام خانوادگی"/>
                                {
                                    validationError['name'] && Array.isArray(validationError['name']) ?

                                        validationError['name'].map((item, index) => {
                                            return (
                                                <div className={"row"} key={index}>
                                                    <div key={index} className={"validation-error"}>
                                                        {item}
                                                    </div>
                                                </div>)
                                        })
                                        : null
                                }
                            </div>
                            <div className="col-lg-6 mb-4">
                                <label htmlFor="email" className="form-label">پست الکترونیک</label>
                                <input value={email} onChange={(event => setEmail(event.target.value))} id={"email"} type="email"
                                       className={"form-control " + (validationError['email'] && Array.isArray(validationError['email']) ? 'not-valid ' : '')}
                                       placeholder="پست الکترونیک"/>
                                {
                                    validationError['email'] && Array.isArray(validationError['email']) ?

                                        validationError['email'].map((item, index) => {
                                            return (
                                                <div className={"row"} key={index}>
                                                    <div key={index} className={"validation-error"}>
                                                        {item}
                                                    </div>
                                                </div>)
                                        })
                                        : null
                                }
                            </div>
                        </div>

                        <button disabled={updateUserLoading} className={"btn btn-honari px-5 py-2"}>{updateUserLoading ? 'در حال ارسال اطلاعات' : 'ثبت'}</button>

                    </form>
                    <br/>
                    <hr />
                    <br/>

                    <form onSubmit={passwordFormSubmit}>

                        <div className="row">
                            <div className="col-lg-6 mb-4">
                                <label htmlFor="password" className="form-label">رمز عبور</label>
                                <input value={password} onChange={(event => setPassword(event.target.value))} id={"password"} type="password"
                                       className={"form-control " + (validationError['password'] && Array.isArray(validationError['password']) ? 'not-valid ' : '')}
                                       placeholder="رمز عبور"/>
                                {
                                    validationError['password'] && Array.isArray(validationError['password']) ?

                                        validationError['password'].map((item, index) => {
                                            return (
                                                <div className={"row"} key={index}>
                                                    <div key={index} className={"validation-error"}>
                                                        {item}
                                                    </div>
                                                </div>)
                                        })
                                        : null
                                }
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-6 mb-4">
                                <label htmlFor="newPassword" className="form-label">رمز عبور جدید</label>
                                <input value={newPassword} onChange={(event => setNewPassword(event.target.value))} id={"newPassword"} type="password"
                                       className={"form-control " + (validationError['newPassword'] && Array.isArray(validationError['newPassword']) ? 'not-valid ' : '')}
                                       placeholder="رمز عبور جدید"/>
                                {
                                    validationError['newPassword'] && Array.isArray(validationError['newPassword']) ?

                                        validationError['newPassword'].map((item, index) => {
                                            return (
                                                <div className={"row"} key={index}>
                                                    <div key={index} className={"validation-error"}>
                                                        {item}
                                                    </div>
                                                </div>)
                                        })
                                        : null
                                }
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-6 mb-4">
                                <label htmlFor="newPassword" className="form-label">تکرار رمز عبور</label>
                                <input value={newPasswordConfirm} onChange={(event => setNewPasswordConfirm(event.target.value))} id={"newPasswordConfirm"} type="password"
                                       className={"form-control " + (validationError['newPasswordConfirm'] && Array.isArray(validationError['newPasswordConfirm']) ? 'not-valid ' : '')}
                                       placeholder="تکرار رمز عبور"/>
                                {
                                    validationError['newPasswordConfirm'] && Array.isArray(validationError['newPasswordConfirm']) ?

                                        validationError['newPasswordConfirm'].map((item, index) => {
                                            return (
                                                <div className={"row"} key={index}>
                                                    <div key={index} className={"validation-error"}>
                                                        {item}
                                                    </div>
                                                </div>)
                                        })
                                        : null
                                }
                            </div>
                        </div>


                        <button disabled={updatePasswordLoading} className={"btn btn-honari px-5 py-2"}>{updatePasswordLoading ? 'در حال ارسال اطلاعات' : 'تغییر کلمه عبور'}</button>


                    </form>

                </div>
            </div>



        </div>
    </React.Fragment>
}

export default EditUser;
